import { IBarValue, Data } from "./BarsValueInterfaces";
import { localeFormattedNumber } from "utilities/utilities";

export const BarValue = ({ bars, xScale }: IBarValue) => {
    return bars.map(({ data: { data, indexValue }, y, height }: Data, i: number) => {
        const values = Object.values(data).filter((item: string | number) => typeof item === "number");
        const total = values.reduce((acc: string | number, current: string | number) => +acc + +current, 0);

        return (
            <g transform={`translate(${xScale(total as number)})`} key={`${indexValue}-${i}`}>
                <text
                    className="bar-total-label"
                    x={height - height / 1.1}
                    y={y + height / 1.5}
                    textAnchor="start"
                    alignmentBaseline="baseline"
                    style={{
                        fill: "rgb(51, 51, 51)",
                    }}
                >
                    {localeFormattedNumber(data.countryCode as string, total)}
                </text>
            </g>
        );
    });
};
